import * as H from "history";
import * as React from "react";
import styled, { css } from "styled-components";

import { breakpoint } from "src/library/utils/styled-media-queries";
import { Datetime } from "src/library/components/Datetime";
import { Text } from "src/library/components/Text/Text";
import Grid from "src/library/components/Hedron";
import { SupportTicketWithType } from "src/modules/support/api/support.api";
import SupportTicketStatus from "src/modules/support/components/SupportTicketStatus";

interface SupportTicketCardProps {
  ticket: SupportTicketWithType;
  history: H.History;
}
/**
 * Component to display the support ticket details
 * in a styled card
 */
export const SupportTicketCard: React.ReactFCWithChildren<SupportTicketCardProps> = ({ ticket, history }) => {
  return (
    <SupportTicketCardWrapper
      onClick={() => history.push(`/support/tickets/${ticket.id}`)}
    >
      <div className="left">
        <Text fontSize="h3">
          {ticket.supportTicketType.name}
        </Text>
      </div>

      <div className="right">
        <Text className="ticket-date">
          <Datetime
            date={ticket.updatedAt}
            template="time_since"
          />
        </Text>

        <SupportTicketStatus status={ticket.status} />
      </div>
    </SupportTicketCardWrapper>
  );
};

const SupportTicketCardWrapper = styled(Grid.Bounds)`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    
    background: ${theme.colors.white};
    padding: ${theme.spacing.padding.md} ${theme.spacing.padding.sm};
    border: ${theme.colors.lightGrey} solid 1px;
    margin-bottom: ${theme.spacing.margins.md};
    width: 100%;
    transition: ${theme.transition};
    flex-direction: column;

    .right {
      flex-wrap: wrap;
      display: flex;
    }

    .ticket-date {
      margin-right: ${theme.spacing.margins.md};
    }

    &:hover {
      cursor: pointer;
      border-color: ${theme.colors.primaryDark};
    }

    ${breakpoint("md", theme)} {
      flex-direction: row;
      align-items: center;
    }
  `}
`;
